module.exports = __webpack_public_path__ + "static/media/Chemistry.320de9d2.svg";